import React, { memo, useEffect, useState } from "react";
import "./styles.scss";
import { Button, Spinner } from "react-bootstrap";
import {
  convertSecondsIntoMinutesAndHours,
  formatAMPM,
} from "../../../utils/formater";
import TooltipComponent from "../Tooltip/Tooltip";
import moment from "moment";
import BsClock from "../../../constants/icons/Bs/BsClock";
import RxStopwatch from "../../../constants/icons/Rx/RxStopwatch";
import BsCalendar4Event from "../../../constants/icons/Bs/BsCalendar4Event";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as ExamSlice from "../../../store/examSlice";
import { toast } from "react-toastify";
import { getExamAttemptById } from "../../../utils/assessments";
import StopFullLengthExamAttempt from "../../Classroom/StopFullLengthExamAttempt";

const FullLengthExams = ({
  onActionHandler = () => {},
  activitesList = [],
  isMobileView = false,
  isShowLoadMore = false,
  loadMore = () => {},
  classroomId = "",
  loading = false,
  roleOfTheUser = "",
  hasIeltsExams
}) => {
  const [stopStart, setStopStart] = useState(false);
  const [viewAttemptLoading, setViewAttemptLoading] = useState(false);
  const [selectedAttempt, setSelectedAttempt] = useState("");

  const [isTabScreen, setIsTabScreen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getStartedHandler = () => {
    navigate(`/student/myClassrooms/${classroomId}/full-length-exams`);
  };
  const handleStartClick = (examId) => {
    if(hasIeltsExams) {
      navigate(
        `${
          roleOfTheUser === "Student" ? "/student" : ""
        }/myClassrooms/${classroomId}/ielts-exams/${examId?._id}`,
      );
    } else {
      navigate(
        `${
          roleOfTheUser === "Student" ? "/student" : ""
        }/${classroomId}/exams/${examId}/details`,
      );
    }
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabScreen(window.innerWidth >= 768); // 768px is a common tablet+ threshold
    };

    checkScreenSize(); // initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const getAttemptHandler = async (attemptId, setLoader) => {
    let attemptData = null;
    try {
      setLoader(true);
      const resp = await getExamAttemptById(attemptId);
      if (resp?.examAttempt) {
        attemptData = structuredClone(resp?.examAttempt);
      }
      setLoader(false);
    } catch (err) {
      toast.error("Failed to delete saved exam");
      setLoader(false);
    }
    return attemptData;
  };
  if (activitesList.length === 0) {
    return (
      <div
        style={{
          height: "100%",
          textAlign: "center",
          alignContent: "center",
          gap: "10px",
          display: "grid",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1D2026" }}>
          No recent activity
        </div>
        {!loading && (
          <div>
            <Button
              onClick={getStartedHandler}
              className="start-classroom-styles"
              variant="outline-primary"
            >
              Get Started
            </Button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        padding: `${isMobileView ? "0px" : "5px 8px 0px 8px"}`,
        overflow: loading ? "hidden" : "auto", // Prevent scroll while loading
      }}
    >
      {stopStart && (
        <StopFullLengthExamAttempt
          open={stopStart}
          onClose={() => setStopStart(!stopStart)}
          title={"Exam Device Advisory"}
          message={
            "Please attempt the full-length exam on a laptop for an optimal experience. Mobile devices are not recommended."
          }
        />
      )}
      {activitesList?.length &&
        activitesList.map((activity, ind) => {
          const performdate = moment(activity.createdAt).format(`Do MMMM 'YY`);
          const performTime = formatAMPM(new Date(activity.createdAt));
          const duration = convertSecondsIntoMinutesAndHours(
            activity?.timeSpent,
          );
          let displayTime = "";
          if (duration.hours > 0) {
            displayTime += `${Math.ceil(duration.hours)}h `;
          }
          if (duration.minutes > 0) {
            displayTime += `${Math.ceil(duration.minutes)}m `;
          }
          if (duration.seconds) {
            displayTime += `${Math.ceil(duration.seconds)}s`;
          }
          if (
            duration.hours === 0 &&
            duration.minutes === 0 &&
            duration.seconds === 0
          ) {
            displayTime += "0s";
          }
          return (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      marginRight: isMobileView ? "12px" : "24px",
                      backgroundColor: "#ebebff",
                      borderColor: "#ebebff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "5px",
                      height: "35px",
                      width: "35px",
                    }}
                  >
                    <BsClock color="#564ffd" size={"24px"} />
                  </div>
                  <div>
                    <div
                      className="performance-title-styles"
                      style={{
                        fontSize: isMobileView ? "12px" : "",
                        fontWeight: "bold",
                        lineHeight: isMobileView ? "30px" : "",
                      }}
                    >
                      {isMobileView && activity?.name?.length > 23 ? (
                        <TooltipComponent TooltipText={activity?.name}>
                          <span>
                            {activity?.name?.slice(0, 23)}
                            ...
                          </span>
                        </TooltipComponent>
                      ) : (
                        activity?.name
                      )}
                      {!isMobileView ? (
                        <span className="dashboard-performance-topic-styles">
                          <svg
                            style={{ marginRight: "3px" }}
                            width="6"
                            height="6"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="5.81569"
                              cy="5.30592"
                              r="4.86842"
                              fill="#564ffd"
                            />
                          </svg>
                          {activity?.courseId?.name}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    {!isMobileView ? (
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <RxStopwatch
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />{" "}
                          {displayTime}
                        </div>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <BsClock
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />
                          {performTime}
                        </div>
                        <div
                          style={{
                            marginRight: "24px",
                            display: "flex",
                            fontSize: "12px",
                            alignItems: "center",
                          }}
                        >
                          <BsCalendar4Event
                            style={{
                              marginRight: isMobileView ? "3px" : "6px",
                            }}
                            size={isMobileView ? 10 : 12}
                          />
                          {performdate}
                        </div>
                      </div>
                    ) : (
                      <div className="dashboard-view-details">View Details</div>
                    )}
                  </div>
                </div>
                {!loading ? (
                  <div>
                    {" "}
                    <Button
                      className={
                        isMobileView
                          ? "activity-perform-button-mobile-styles"
                          : "activity-perform-button-styles"
                      }
                      variant="outline-primary"
                      onClick={async () => {
                        if(hasIeltsExams) {
                          // For IELTS, store attempt ID in sessionStorage and navigate to results
                          sessionStorage.setItem(
                            "fullExamAttemptId",
                             activity?._id,
                          );
                          setViewAttemptLoading(true);
                          setTimeout(() => {
                            navigate(
                              `${
                                roleOfTheUser === "Student"
                                  ? "/student"
                                  : ""
                              }/myClassrooms/${classroomId}/ielts-exams/${
                                activity?.examId?._id
                              }/attempt/results`,
                            );
                          }, 500);
                          return
                        }
                        if (!isTabScreen) {
                          setStopStart(true);
                          return;
                        }

                        setSelectedAttempt(activity?._id);
                        setViewAttemptLoading(true);
                        try {
                          const resp = await getExamAttemptById(activity?._id);
                          if (resp?.examAttempt) {
                            dispatch(
                              ExamSlice.setExamData({
                                ...JSON.parse(resp?.examAttempt?.data),
                                updatedAt: activity?.updatedAt,
                                urlData: JSON.parse(resp?.examAttempt?.url),
                              }),
                            );
                            navigate(
                              `${
                                roleOfTheUser === "Student" ? "/student" : ""
                              }/${classroomId}/exams/${
                                activity?.examId
                              }/result?attemptId=${activity?._id}`,
                            );
                          } else {
                            toast.error("Failed to fetch exam attempt data");
                          }
                        } catch (err) {
                          toast.error("Failed to fetch exam attempt data");
                        } finally {
                          setViewAttemptLoading(false);
                        }
                      }}
                    >
                      {viewAttemptLoading &&
                      activity?._id === selectedAttempt ? (
                        <Spinner
                          style={{
                            height: "20px",
                            width: "20px",
                          }}
                        />
                      ) : (
                        "View Solution"
                      )}
                    </Button>
                    <Button
                      className={
                        isMobileView
                          ? "activity-perform-button-mobile-styles"
                          : "activity-perform-button-styles"
                      }
                      variant="outline-primary"
                      onClick={() => {
                        if (!isTabScreen) {
                          setStopStart(true);
                        } else {
                          handleStartClick(activity?.examId);
                        }
                      }}
                    >
                      Reattempt
                    </Button>
                  </div>
                ) : (
                  <div style={{ color: "#564ffd", fontWeight: "500" }}>
                    {/* Score: {activity.correct} / {activity.totalQuestions} */}
                  </div>
                )}
              </div>
              <hr style={{ margin: "0px" }} />
            </>
          );
        })}
      {!loading && activitesList.length && isShowLoadMore ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Button
              className={"load-more-button-styles"}
              variant="outline-primary"
              onClick={loadMore}
            >
              {" "}
              Load More ...
            </Button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(FullLengthExams);
